<template>
  <div>
    <b-table v-bind="$attrs" selectable select-mode="single" hover>
      <slot />
      <slot name="thead-top" slot="thead-top" />

      <!-- Define the Tables busy state -->
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell()="$attrs">
        <router-link
          v-if="$attrs.field.link === true"
          :to="$attrs.item.id"
          append
        >
          {{ $attrs.item[$attrs.field.key] }}
        </router-link>
        <div v-else>
          {{ $attrs.item[$attrs.field.key] }}
        </div>
      </template>
    </b-table>

    <div class="table-footer">
      <div class="table-settings">
        <label for="num_per_page"> Rows Per Page </label>
        <b-form-select
          id="num_per_page"
          size="sm"
          :options="pageSizeOptions"
          v-model="currentPageSize"
          @change="$emit('pageSizeChanged', currentPageSize)"
        />
      </div>
      <div class="page-counter">
        <b-skeleton v-if="totalPages === null" />
        <span v-else> {{ currentPage }} of {{ totalPages }} </span>
      </div>
      <div class="table-nav">
        <div @click="changePage(-1)"><BIcon icon="caret-left-fill" /></div>
        <div @click="changePage(1)"><BIcon icon="caret-right-fill" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue'

export default {
  components: {
    BIcon
  },
  data() {
    return {
      pageSizeOptions: [10, 30, 50],
      currentPageSize: 10
    }
  },
  props: {
    totalItems: {
      type: Number
    },
    pageSize: {
      default: 10,
      type: Number
    },
    currentPage: {
      default: 1,
      type: Number
    },
    totalPages: {
      default: null,
      type: Number
    }
  },
  mounted() {
    this.currentPageSize = this.pageSize
  },
  methods: {
    changePage(offset) {
      const newPage = this.currentPage + offset
      if (newPage > 0 && newPage <= this.totalPages) {
        this.$emit('pageChanged', this.currentPage + offset)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: $gray;
  background: lighten($gray, 47%);
  font-size: small;
  padding: 10px;
}

.custom-select {
  background-color: transparent;
  padding-top: 0;
  padding-bottom: 0;
  height: 25px;
}

.table-settings,
.page-counter,
.table-nav {
  display: flex;
  white-space: nowrap;
  align-items: center;

  & + & {
    margin-left: 30px;
  }
}

label {
  margin: 0;
  margin-right: 20px;
}

.b-skeleton {
  width: 50px;
}
</style>
